import Kr from 'Kr/kr';
import 'KrComponent/MenuMobile';
import 'KrComponent/LayoutGallery';
import 'KrComponent/LayoutSlider';
import 'KrComponent/NavTo';

import LinkClass from 'KrModule/LinkClass';

const app = new Kr.App;

app.use('link-class', LinkClass);
app.run();
